if ('NodeList' in window && !NodeList.prototype.forEach) {
    console.info('polyfill for IE11');
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (let i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

function loginMembers(e) {
    console.log('login...');
    e.preventDefault();

    let formId = "loginForm",url = "/ajax/functions.php",formData = new FormData();
    document.querySelector(`#${formId} .errorMsg`).style.opacity = '0';

    formData.append('operation', 'loginMembers');
    formData.append('password_member', document.getElementById("password_member").value);

    fetch(url, {
        method: 'POST',
        body: formData
    }).then(response => response.json())
        .then(data => {
        if (data.result === 'success') {
            sessionStorage.setItem("isLoged", true);
            location.reload();
        } else {
            document.querySelector(`#${formId} .errorMsg`).style.opacity = '1';
        }
    }).catch(error => console.error('Error:', error));
}

(function(){
    document.documentElement.style.setProperty("--header-offset", document.getElementById("header").clientHeight + document.getElementById("header").offsetTop + 'px');

    // Remove empty <p> tags created by tinymce
    const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach( e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));


    $('.sym-slides').slick({
        accessibility: true
    });
    
    $('.gallery-slider').slick({
        accessibility: true
    });
    
    /* document.querySelectorAll('.gallery-block__img').forEach(item => {
        item.addEventListener('click', () => {
            setTimeout(() => {
                let fancyboxInfo = document.querySelector('.fancybox-infobar span[data-fancybox-count]');
                fancyboxInfo.innerHTML = fancyboxInfo.length;
            }, 0);
        });
    }); */

    $('.columns-block-slides').slick({
        accessibility:true,
        slidesToShow : 3,
        slidesToScroll:1,
        autoplay:true,
        autoplaySpeed:4000,
        speed:400,
        appendArrows: '#columns-block-arrows',
        adaptiveHeight: true,
        responsive: [
            {
                breakpoint: 1000,
                settings: {
                    slidesToShow : 2,
                    infinite: true,
                }
            },
            {
                breakpoint: 700,
                settings: {
                    slidesToShow : 1,
                    fade:true,
                    adaptiveHeight: false
                }
            }
        ]
    })

    $('.images-slider').slick({
        arrows: true,
        autoplay: false,
        autoplaySpeed: 4000,
        speed: 300,
        fade: true 
    })
    

    $(".home-slider__arrows .slick-prev").click(function(){
        $(".sym-slides").slick("slickPrev");
    });
    $(".home-slider__arrows .slick-next").click(function(){
        $(".sym-slides").slick("slickNext");
    });

    $("#gallery-block__arrows .slick-prev").click(function(){
        $(".gallery-slider").slick("slickPrev");
    });
    $("#gallery-block__arrows .slick-next").click(function(){
        $(".gallery-slider").slick("slickNext");
    });

    $(".slider-block__arrows .slick-prev").click(function(){
        $(".sym-slides").slick("slickPrev");
    });
    $(".slider-block__arrows .slick-next").click(function(){
        $(".sym-slides").slick("slickNext");
    });

    var ua = navigator.userAgent.toLocaleLowerCase();

    //tabs content
    document.querySelectorAll('.tab-content__tabs li').forEach((btn, i) => {
        btn.addEventListener('click', _ => {
            document.querySelectorAll('.tab-content__tabs li').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');
            activeContentItem(btn.dataset.tag);
            // document.querySelectorAll('.tab-content__item').forEach(room => {
            //     room.classList.remove('active');
            //     if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
            //         room.classList.add('active');
            //     }
            // });
        });

        if (i === 0) btn.click();
    });

    let prevtArrow = document.getElementsByClassName("tab-prev-js"),
        nextArrow  = document.getElementsByClassName("tab-next-js"),
        arrayItems = document.querySelectorAll('.tab-content__tabs li');

    Array.from(nextArrow).forEach(arrow =>{
        arrow.addEventListener('click',()=>{
            let count = 0; 
            arrayItems.forEach(item => {   
                if(item.classList.contains('active') && count===0){
                    let valor = item.nextElementSibling;
                    item.classList.remove('active');
                    if(valor != undefined){
                        valor.classList.add('active');
                        activeContentItem(valor.dataset.tag)
                    }else{
                        const firstItem = arrayItems[0];                   
                        firstItem.classList.add('active');
                        activeContentItem(firstItem.dataset.tag)
                    }
                    count++;
                }
            });
        });
    })

    Array.from(prevtArrow).forEach(arrow =>{
        arrow.addEventListener('click',()=>{
            let count = 0; 
            arrayItems.forEach(item => {   
                if(item.classList.contains('active') && count===0){
                    let valor = item.previousElementSibling;
                    item.classList.remove('active');
                    if(valor != undefined){
                        valor.classList.add('active');
                        activeContentItem(valor.dataset.tag)
                    }else{
                        const lastItem = arrayItems[arrayItems.length -1];                   
                        lastItem.classList.add('active');
                        activeContentItem(lastItem.dataset.tag)
                    }
                    count++;
                }
            });
        });
    })


    function activeContentItem(tag){
        document.querySelectorAll('.tab-content__item').forEach(room => {
            room.classList.remove('active');
            if ( tag === 'all' || tag === room.dataset.tag ) {
                room.classList.add('active');
            }
        }); 
    }

    //transform submenu in select mobile
        let hasSubmenu = document.querySelector(".tabs-mobile-js");
        if (hasSubmenu != undefined) {
        $(".tabs-mobile-js").click(function () {
        let is_open = $(this).hasClass("open");
        if (is_open) {
        $(this).removeClass("open");
        } else {
        $(this).addClass("open");
        }
        });
        $(".tabs-mobile-js li").click(function () {
        let valor = this.childNodes[0].textContent;
        let first_li = $(".tabs-mobile-js li:first-child")[0].childNodes[0];
        first_li.textContent=valor;
        });
        }



    //for Menus
    document.querySelectorAll('.menu-restaurant__tabs li').forEach((btn, i) => {
        btn.addEventListener('click', _ => {
            document.querySelectorAll('.menu-restaurant__tabs li').forEach(b => b.classList.remove('active'));
            btn.classList.add('active');

            document.querySelectorAll('.menu__unitmenu').forEach(room => {
                room.classList.remove('active');
                if ( btn.dataset.tag === 'all' || btn.dataset.tag === room.dataset.tag ) {
                    room.classList.add('active');
                }
            });
        });

        if (i === 0) btn.click();
    });

    //For accordion quad
    $('.accordion .accordion__content').hide();
    $('.accordion .accordion__item:first').addClass("active").find(".accordion__content").slideDown();
    $('.accordion .accordion__title:first').addClass("active");
    
    $('.accordion__item').click(function(e) {
        e.stopPropagation()
        
        if ($(this).hasClass("active")) {
            $(this).removeClass("active");
            $(this).find(".accordion__content").slideUp();

        } else {
            $(".accordion__item.active .accordion__content").slideUp();
            $(".accordion__item.active").removeClass("active");
            $(this).addClass("active").find(".accordion__content").slideDown(function(){
                $("html, body").stop().animate({ scrollTop: $(".accordion__item.active").offset().top-100 }, 1000);
                //console.log($(".accordion__item.active").offset().top );
            });
            
        }
    });

    if(location.hash.length>0){

        let url = window.location.hash.replace("#", "");
        $('.'+ url).trigger('click');

        let gosection = document.getElementById("tab-content");
        $(document).scrollTop( gosection.offsetTop );
    }

    // Add class nav cards filter
        let cardsFilterTags = document.querySelectorAll('.cards-filter__tag');

        if (cardsFilterTags.length > 0) {
            cardsFilterTags.forEach(tag => {
                tag.addEventListener('click', function() {
                    cardsFilterTags.forEach(el => el.classList.remove('active'));
                    this.classList.add('active');
                });
            });
        }

})();

/** ADA Tab Links Functionality for Keyboard Navigation in Menu **/

function updateMenuTabIndex() {
    const menu = document.querySelector('#menu-block');
    const isMenuVisible = menu && menu.classList.contains('active');
    const elements = document.querySelectorAll('.privary-navigation__item a');
    
    elements.forEach(element => {
        element.setAttribute('tabindex', isMenuVisible ? '0' : '-1');
    });
}

document.addEventListener('DOMContentLoaded', () => {
    updateMenuTabIndex();

    document.addEventListener('focusin', updateMenuTabIndex);
    const menu = document.querySelector('#menu-block');
    if (menu) {
        menu.addEventListener('transitionend', updateMenuTabIndex);
    }

    let all_floorplan_cta = document.querySelectorAll('.floorplan-cta');
    if( all_floorplan_cta ){
        all_floorplan_cta.forEach( cta => {
            cta.classList.add('animate-fade');
            cta.classList.add('top');
            setTimeout(() => {
                cta.classList.add('fade-in');
            }, 1000);
        } );
    }

    let button_brand_pics = document.querySelectorAll('.js-brand-pics .brand-pics_links a[download]');
    if( button_brand_pics ){
        button_brand_pics.forEach( buttonOfPics => {
            buttonOfPics.addEventListener( 'click', event => {
                event.preventDefault();
                if( sessionStorage.getItem('isLoged') != 'true' ){
                    document.getElementById('buttonToActiveLoginForm').click();
                }
            } );
        } );
    }
});
